<template>
  <div>
    <div
      v-if="campoObservacao && autenticacao"
      class="row col-md-10 col-xs-12 q-mt-md q-mb-lg q-mx-md"
    >
      <CampoObservacao v-model="observacao" />
    </div>
    <div
      class="row col-12 text-brand-5 text-weight-bold container-selecao-autenticacao"
      v-if="!solicitanteAuteticacao && autenticacao"
    >
      <div
        class="q-my-lg q-ml-sm row col-12 text-brand-5 text-weight-bold items-center justify-between"
      >
        <div class="titulo-autenticacao">
          Método de Autenticação - Solicitante
          {{
            metodoAutenticacao.solicitante.obrigatorio == "sim"
              ? "(Obrigatório)"
              : ""
          }}
        </div>
        <div class="row status-autenticacao">
          <div class="row items-center q-mr-sm">
            <div>Solicitante</div>
            <div
              v-if="solicitanteAuteticacao"
              class="elipse bg-positive q-ml-xs"
            ></div>
            <div v-else class="elipse bg-negative q-ml-xs"></div>
          </div>
          <div class="row items-center">
            <div>Almoxarife</div>
            <div
              v-if="almoxarifeAutenticacao"
              class="elipse bg-positive q-ml-xs"
            ></div>
            <div v-else class="elipse bg-negative q-ml-xs"></div>
          </div>
        </div>
      </div>

      <div
        v-for="(metodo, index) in metodoAutenticacao.solicitante.metodos"
        :key="index"
      >
        <q-radio
          :val="metodo"
          :label="`${metodo?.charAt(0)?.toUpperCase()}${metodo?.substring(1)}`"
          v-model="metodoSolicitante"
          :disable="metodo == 'biometria' && mobile"
        />
      </div>
      <div
        class="row col-12 q-mt-lg q-ml-md items-center container-autenticacao-pin"
        v-if="metodoSolicitante === 'pin'"
      >
        <q-icon class="q-mr-xs" name="lock" size="28px" />
        <div class="col-md-2 col-xs-6">
          <q-input v-model="pin" type="password" dense outlined />
        </div>
      </div>

      <div
        @click="facial = true"
        style="cursor: pointer"
        class="row col-12 q-mt-lg q-ml-md items-center container-autenticacao-assinatura"
        v-if="metodoSolicitante === 'facial'"
      >
        <div class="relative-position" style="display: inline-block">
          <q-icon
            size="60px"
            class="q-mr-xs"
            name="face"
            :color="base64 == null ? 'negative' : 'positive'"
          />

          <q-icon
            :name="base64 == null ? 'cancel' : 'check_circle'"
            :style="{
              color: base64 == null ? '#C62828' : '#2E7D32',
            }"
            size="22px"
            class="absolute-bottom-right"
            style="bottom: 2px; right: -2px; z-index: 0"
          >
            <q-tooltip
              anchor="top middle"
              self="bottom middle"
              :class="
                base64 == null ? 'bg-gray text-white' : 'bg-gray text-white'
              "
            >
              {{
                base64 == null
                  ? "Face não capturada"
                  : "Face capturada com sucesso"
              }}
            </q-tooltip>
          </q-icon>
        </div>
        <span class="q-ml-sm text-bold text-brand-5" style="font-size: 16px"
          >Clique aqui para reconhecimento da face, após leitura, clique em
          CONFIRMAR FACE</span
        >
        <VerificacaoFacial
          :userId="usuario?.idTabela"
          v-model="facial"
          @close="fecharFacial"
          @sendFace="receberFace"
        />
      </div>
      <div
        class="row col-12 q-mt-lg q-ml-md items-center container-autenticacao-assinatura"
        v-if="metodoSolicitante === 'assinatura'"
      >
        <Canvas @update="receberAssinatura" :go="salvarAssinatura" />
      </div>
      <div
        v-if="!mobile && metodoSolicitante === 'biometria'"
        class="row col-12 q-mt-lg q-ml-md items-center"
      >
        <div v-if="usuario.biometria">
          <q-img
            v-if="biometriaVerificacaoSolicitante"
            class="imagem-biometria"
            src="../../../assets/bioOK.png"
            @click="biometriaModal = !biometriaModal"
          />
          <q-img
            v-else
            class="imagem-biometria"
            src="../../../assets/bioRequest.png"
            @click="biometriaModal = !biometriaModal"
          />
          <span class="q-ml-sm text-bold text-brand-5" style="font-size: 16px"
            >Clique no icone da digital para reconhecimento da biometria.</span
          >
          <BiometriaModal
            :modal="biometriaModal"
            :userId="usuario?.idTabela"
            :titulo="'Verificação de Biometria'"
            :tipoBiometria="'verificacao'"
            @negativePrint="recebeBiometria"
            @resultadoVerificacao="receberResultadoBiometriaSolicitante"
          />
        </div>
        <div v-else>
          <q-img
            class="imagem-biometria"
            src="../../../assets/bioNO.png"
            @click="biometriaModal = !biometriaModal"
          />
          <span class="q-ml-sm text-bold text-brand-5" style="font-size: 14px"
            >O funcionário não possuiu biometria cadastrada, favor clicar no
            icone e realizar o procedimento de cadastro.</span
          >
          <BiometriaModal
            :titulo="'Cadastro de Biometria'"
            :modal="biometriaModal"
            :tipoBiometria="'cadastro'"
            :userId="usuario?.idTabela"
            @atualizarBiometrias="atualizarTemplatesBiometria"
          />
        </div>
      </div>
    </div>
    <div
      class="row col-12 text-brand-5 text-weight-bold container-selecao-autenticacao"
      v-if="autenticacao && solicitanteAuteticacao"
    >
      <div
        class="q-my-lg q-ml-sm row col-12 text-brand-5 text-weight-bold items-center justify-between"
      >
        <div class="titulo-autenticacao">
          Método de Autenticação - Almoxarife
          {{
            metodoAutenticacao.almoxarife.obrigatorio == "sim"
              ? "(Obrigatório)"
              : ""
          }}
        </div>
        <div class="row status-autenticacao">
          <div class="row items-center q-mr-sm">
            <div>Solicitante</div>
            <div
              v-if="solicitanteAuteticacao"
              class="elipse bg-positive q-ml-xs"
            ></div>
            <div v-else class="elipse bg-negative q-ml-xs"></div>
          </div>
          <div class="row items-center">
            <div>Almoxarife</div>
            <div
              v-if="almoxarifeAutenticacao"
              class="elipse bg-positive q-ml-xs"
            ></div>
            <div v-else class="elipse bg-negative q-ml-xs"></div>
          </div>
        </div>
      </div>

      <div
        v-for="(metodo, index) in metodoAutenticacao.almoxarife.metodos"
        :key="index"
      >
        <q-radio
          :val="metodo"
          :label="`${metodo?.charAt(0)?.toUpperCase()}${metodo?.substring(1)}`"
          v-model="metodoAlmoxarife"
        />
      </div>
      <div
        class="row col-12 q-mt-lg q-ml-md items-center container-autenticacao-pin"
        v-if="metodoAlmoxarife === 'pin'"
      >
        <q-icon class="q-mr-xs" name="lock" size="28px" />
        <div class="col-md-2 col-xs-6">
          <q-input v-model="pin" type="password" dense outlined />
        </div>
      </div>
      <div
        class="row col-12 q-mt-lg q-ml-md items-center container-autenticacao-assinatura"
        v-if="metodoAlmoxarife === 'assinatura'"
      >
        <Canvas @update="receberAssinatura" :go="salvarAssinatura" />
      </div>
      <div
        class="row col-12 q-mt-lg q-ml-md items-center"
        v-if="!mobile && metodoAlmoxarife === 'biometria'"
      >
        <div v-if="userLogado?.biometry">
          <q-img
            v-if="biometriaVerificacaoAlmoxarife"
            class="imagem-biometria"
            src="../../../assets/bioOK.png"
            @click="biometriaModal = !biometriaModal"
          />
          <q-img
            v-else
            class="imagem-biometria"
            src="../../../assets/bioRequest.png"
            @click="biometriaModal = !biometriaModal"
          />
          <span class="q-ml-sm text-bold text-brand-5" style="font-size: 16px"
            >Clique no icone da digital para reconhecimento da biometria.</span
          >
          <BiometriaModal
            :modal="biometriaModal"
            :userId="userLogado?.id"
            :titulo="'Verificação de Biometria'"
            :tipoBiometria="'verificacao'"
            @negativePrint="recebeBiometria"
            @resultadoVerificacao="receberResultadoBiometriaAlmoxarife"
          />
        </div>
        <div v-else>
          <q-img
            class="imagem-biometria"
            src="../../../assets/bioNO.png"
            @click="biometriaModal = !biometriaModal"
          />
          <span class="q-ml-sm text-bold text-brand-5" style="font-size: 14px"
            >O funcionário não possuiu biometria cadastrada, favor clicar no
            icone e realizar o procedimento de cadastro.</span
          >
          <BiometriaModal
            :titulo="'Cadastro de Biometria'"
            :modal="biometriaModal"
            :tipoBiometria="'cadastro'"
            :userId="userLogado?.id"
            @atualizarBiometrias="atualizarTemplatesBiometria"
          />
        </div>
      </div>
    </div>
    <div class="q-mt-xl q-ml-sm">
      <div v-if="!autenticacao">
        <q-btn
          :label="getLabelBotao()"
          no-caps
          icon="add"
          class="btn"
          :disable="disable || desabilitarBotaoCriar"
          style="background-color: #21324a; border-radius: 8px; color: white"
          @click="iniciarAutenticacao()"
        />
      </div>
      <div class="row col-12 q-gutter-sm" v-else>
        <q-btn
          icon="done"
          :label="labelBotao"
          no-caps
          class="btn"
          style="background-color: #21324a; border-radius: 8px; color: white"
          @click="verificarTipoAutenticacao()"
          :disable="disable || desabilitarBotaoCriar"
        />
        <q-btn
          label="Cancelar"
          icon="cancel"
          no-caps
          color="red"
          :disable="disable || desabilitarBotaoCriar"
          @click="resetarVariaveis()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { setupConfiguracao } from "../composables/setupConfiguracao";
import { useQuasar } from "quasar";
import { useStore } from "vuex";
import VerificacaoFacial from "../../requisicao/components/VerificacaoFacial.vue";
import Canvas from "../components/Canvas.vue";
import BiometriaModal from "../../biometria/views/Biometria.vue";
import CampoObservacao from "./CampoObservacao.vue";

export default {
  props: [
    "usuario",
    "autenticacao",
    "etapa",
    "fazerAutenticacao",
    "resetar",
    "atualizarUserLogado",
    "desabilitarBotaoCriar",
    "campoObservacao",
    "isRenovacao",
  ],
  emits: [
    "iniciarAutenticacao",
    "finalizarProcesso",
    "atualizarTemplates",
    "enviarAutenticacaoSolicitante",
    "enviarAutenticacaoAlmoxarife",
    "enviarSetupConfiguracao",
    "resetarAutenticacao",
  ],
  components: {
    Canvas,
    BiometriaModal,
    CampoObservacao,
    VerificacaoFacial,
  },
  setup(props, { emit }) {
    const setupDado = setupConfiguracao();
    const quasar = useQuasar();
    const store = useStore();

    const dado = ref({});
    const file = ref(null);
    const observacao = ref("");
    let biometriaModal = ref(false);
    let solicitanteAuteticacao = ref(false);
    let almoxarifeAutenticacao = ref(false);
    const metodoAutenticacao = ref({ solicitante: {}, almoxarife: {} });
    let mobile = ref(false);
    const salvarAssinatura = ref(0);
    const labelBotao = ref("");
    const base64 = ref(null);
    const pin = ref("");
    const individoAutenticacao = ref("solicitante");
    const biometriaVerificacaoSolicitante = ref(false);
    const biometriaVerificacaoAlmoxarife = ref(false);
    const userLogado = ref({});
    let disable = ref(false);
    const metodoSolicitante = ref("");
    const metodoAlmoxarife = ref("");
    const respostas = ref({ responderCheckLists: "", responderAcessorios: "" });
    const processoFinalizando = ref(false);
    const processoFinalizado = ref(false);
    const facial = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const receberDadoSetup = async () => {
      if (setupDado.dadoSetupAutenticacao.value.length == 0) {
        return;
      }
      setupDado.dadoSetupAutenticacao.value.forEach((value) => {
        if (value.etapa === props.etapa) {
          metodoAutenticacao.value.solicitante = value.autenticacao[0];
          metodoAutenticacao.value.almoxarife = value.autenticacao[1];
          respostas.value = {
            responderCheckLists: value?.responderCheckLists,
            responderAcessorios: value?.responderAcessorios,
          };
          return;
        }
      });
      enviarSetupConfiguracao();
    };

    const selecionarTipoAutenticacaoSolicitante = async () => {
      definirLabelBotao();
      if (metodoSolicitante.value === "assinatura") {
        salvarAssinatura.value++;
        return;
      }
      if (metodoSolicitante.value == "facial") {
        if (base64.value == null) {
          quasar.notify({
            message: "Faça a verificação facial antes de continuar o processo.",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          disable.value = false;

          return;
        } else {
          disable.value = false;
          enviarAutenticacao("facial", base64.value, "solicitante");
        }
        return;
      }
      if (metodoSolicitante.value === "biometria") {
        if (!biometriaVerificacaoSolicitante.value && base64.value != null) {
          quasar.notify({
            message:
              "A biometria não concide com o a digital verificada, faça o procedimento novamente ou escolha outro metodo de autenticação.",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          base64.value = null;
          disable.value = false;
          return;
        }

        if (
          base64.value == null &&
          !metodoAutenticacao.value[
            individoAutenticacao.value
          ].metodos.includes("token") &&
          metodoAutenticacao.value[individoAutenticacao.value].obrigatorio ==
            "sim"
        ) {
          quasar.notify({
            message: "Faça a coleta da biometria.",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          disable.value = false;
          base64.value = null;
          return;
        }
        if (base64.value != null) {
          receberUrlEmprestimoAutenticacao("biometria", "solicitante");
          return;
        }
        enviarAutenticacao(
          "token",
          store.state.autenticacao.token,
          "solicitante"
        );
      }
      if (metodoSolicitante.value === "pin") {
        if (
          pin.value == "" &&
          metodoAutenticacao.value[individoAutenticacao.value].metodos.includes(
            "token"
          )
        ) {
          enviarAutenticacao(
            "token",
            store.state.autenticacao.token,
            "solicitante"
          );
          return;
        }
        verificarPinSolicitante();
        return;
      }
      enviarAutenticacao(
        "token",
        store.state.autenticacao.token,
        "solicitante"
      );
    };

    const finalizarProcessoControlado = (observacaoValor = null) => {
      emit("finalizarProcesso", observacaoValor || observacao.value);
    };

    const selecionarTipoAutenticacaoAlmoxarife = async () => {
      definirLabelBotao();
      if (metodoAlmoxarife.value === "assinatura") {
        salvarAssinatura.value++;
        return;
      }
      if (metodoAlmoxarife.value === "facial") {
        if (base64.value == null) {
          quasar.notify({
            message: "Faça a verificação facial antes de finalizar o processo.",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          disable.value = false;

          return;
        } else {
          disable.value = false;
          enviarAutenticacao("facial", base64.value, "almoxarife");
        }
        return;
      }
      if (metodoAlmoxarife.value === "biometria") {
        if (!biometriaVerificacaoAlmoxarife.value && base64.value != null) {
          quasar.notify({
            message:
              "A biometria não concide com o a digital verificada, faça o procedimento novamente ou escolha outro metodo de autenticação.",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          disable.value = false;
          base64.value = null;
          return;
        }
        if (
          base64.value == null &&
          !metodoAutenticacao.value[
            individoAutenticacao.value
          ].metodos.includes("token") &&
          metodoAutenticacao.value[individoAutenticacao.value].obrigatorio ==
            "sim"
        ) {
          quasar.notify({
            message: "Faça a coleta da biometria.",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          disable.value = false;
          base64.value = null;
          return;
        }
        if (base64.value != null) {
          await receberUrlEmprestimoAutenticacao("biometria", "almoxarife");
          return;
        }
        enviarAutenticacao(
          "token",
          store.state.autenticacao.token,
          "almoxarife"
        );
        finalizarProcessoControlado();
        return;
      }
      if (metodoAlmoxarife.value === "pin") {
        if (
          pin.value == "" &&
          metodoAutenticacao.value[individoAutenticacao.value].metodos.includes(
            "token"
          )
        ) {
          enviarAutenticacao(
            "token",
            store.state.autenticacao.token,
            "almoxarife"
          );
          return;
        }
        verificarPinAlmoxarife();
        return;
      }
      enviarAutenticacao("token", store.state.autenticacao.token, "almoxarife");
    };

    const receberAssinatura = async (value) => {
      if (
        (individoAutenticacao.value == "solicitante" &&
          metodoSolicitante.value === "assinatura") ||
        (individoAutenticacao.value == "almoxarife" &&
          metodoAlmoxarife.value === "assinatura")
      ) {
        if (value == undefined || value == null || value == "") {
          quasar.notify({
            message:
              "A assinatura é obrigatória para este tipo de autenticação.",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          disable.value = false;
          return;
        }
      }

      if (
        ((value == undefined || value == "") &&
          metodoAutenticacao.value[individoAutenticacao.value].metodos.includes(
            "token"
          )) ||
        ((value == undefined || value == "") &&
          metodoAutenticacao.value[individoAutenticacao.value].metodos.length ==
            0)
      ) {
        if (individoAutenticacao.value == "almoxarife") {
          enviarAutenticacao(
            "token",
            store.state.autenticacao.token,
            individoAutenticacao.value
          );
          return;
        }
        enviarAutenticacao(
          "token",
          store.state.autenticacao.token,
          individoAutenticacao.value
        );
        return;
      }

      if (
        (value == "" || value == undefined) &&
        !metodoAutenticacao.value[individoAutenticacao.value].metodos.includes(
          "token"
        ) &&
        metodoAutenticacao.value[individoAutenticacao.value].obrigatorio ==
          "sim"
      ) {
        quasar.notify({
          message: "A assinatura é obrigatória.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disable.value = false;
        return;
      }
      if (
        (value == "" || value == undefined) &&
        !metodoAutenticacao.value[individoAutenticacao.value].metodos.includes(
          "token"
        ) &&
        metodoAutenticacao.value[individoAutenticacao.value].obrigatorio ==
          "nao"
      ) {
        if (individoAutenticacao.value == "almoxarife") {
          enviarAutenticacao(
            "token",
            store.state.autenticacao.token,
            individoAutenticacao.value
          );
          return;
        }
        enviarAutenticacao(
          "token",
          store.state.autenticacao.token,
          individoAutenticacao.value
        );
        return;
      }
      base64.value = value?.split("base64,")[1];
      definirLabelBotao();
      if (individoAutenticacao.value == "almoxarife") {
        await receberUrlEmprestimoAutenticacao("assinatura", "almoxarife");
        almoxarifeAutenticacao.value = true;
        return;
      }
      receberUrlEmprestimoAutenticacao("assinatura", "solicitante");
    };

    const verificarTipoAutenticacao = () => {
      disable.value = true;
      if (solicitanteAuteticacao.value) {
        selecionarTipoAutenticacaoAlmoxarife();
        return;
      }
      selecionarTipoAutenticacaoSolicitante();
    };

    const definirLabelBotao = () => {
      if (props.etapa == "emprestimo") {
        if (solicitanteAuteticacao.value) {
          labelBotao.value = "Finalizar Retirada";
          return;
        }
        labelBotao.value = "Coletar Autenticação";
      }
      if (props.etapa == "devolucao") {
        if (solicitanteAuteticacao.value) {
          labelBotao.value = props.isRenovacao
            ? "Finalizar Renovação"
            : "Finalizar Devolução";
          return;
        }
        labelBotao.value = "Coletar Autenticação";
      }
    };

    const getLabelBotao = () => {
      if (props.isRenovacao) {
        return "Renovar Emprestimo";
      }
      return props.etapa == "emprestimo" ? "Criar Retirada" : "Criar Devolução";
    };

    const iniciarAutenticacao = () => {
      emit("iniciarAutenticacao");
      definirLabelBotao();
    };

    const enviarAutenticacao = (authType, authContent, individuo) => {
      if (individuo == "solicitante") {
        emit("enviarAutenticacaoSolicitante", {
          authType:
            metodoSolicitante.value == undefined ||
            metodoSolicitante.value == ""
              ? "token"
              : metodoSolicitante.value,
          authContent: authContent,
        });
        individoAutenticacao.value = "almoxarife";
        solicitanteAuteticacao.value = true;
        quasar.notify({
          message: "Autenticação do solicitante coletada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disable.value = false;
        return;
      }

      emit("enviarAutenticacaoAlmoxarife", {
        authType:
          metodoAlmoxarife.value == undefined || metodoAlmoxarife.value == ""
            ? "token"
            : metodoAlmoxarife.value,
        authContent: authContent,
      });
      almoxarifeAutenticacao.value = true;

      if (
        metodoAutenticacao.value[individoAutenticacao.value].obrigatorio ==
          "nao" &&
        base64.value == null &&
        (metodoAlmoxarife.value == "assinatura" ||
          metodoAlmoxarife.value == "biometria")
      ) {
        disable.value = false;
        finalizarProcessoControlado();
        return;
      }
      quasar.notify({
        message: "Autenticação do almoxarife coletada com sucesso.",
        color: "positive",
        actions: [
          {
            label: "fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      disable.value = false;
      finalizarProcessoControlado();
    };

    const recebeBiometria = async (value) => {
      base64.value = value;
    };

    const receberUrlEmprestimoAutenticacao = async (tipoImagem, individuo) => {
      file.value = converterBase64Arquivo(
        base64.value,
        tipoImagem,
        "image/png"
      );
      try {
        const response = await store.dispatch(
          "ferramentaria/buscarUrlEmprestimoAutenticacao",
          {
            nomeArquivo: file.value.name,
          }
        );
        let formAttributes = response.data.resultado.dados.formAttributes;
        let formInputs = response.data.resultado.dados.formInputs;
        const formData = new FormData();

        for (let input in formInputs) {
          formData.append(input, formInputs[input]);
        }
        formData.append("file", file.value);
        var request = new XMLHttpRequest();
        request.open(formAttributes.method, formAttributes.action);
        request.send(formData);
        enviarAutenticacao(
          tipoImagem,
          `${formAttributes.action}/${formInputs.key}`,
          individuo
        );
        base64.value = null;
      } catch (error) {
        console.log(error);
      }
    };

    const converterBase64Arquivo = (base64String, nomeArquivo, mimeType) => {
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: mimeType });

      const file = new File([blob], nomeArquivo, { type: mimeType });
      return file;
    };

    const resetarVariaveis = () => {
      solicitanteAuteticacao.value = false;
      almoxarifeAutenticacao.value = false;
      individoAutenticacao.value = "solicitante";
      biometriaVerificacaoSolicitante.value = false;
      biometriaVerificacaoAlmoxarife.value = false;
      definirLabelBotao();
      disable.value = false;
      observacao.value = "";
      processoFinalizando.value = false;
      processoFinalizado.value = false;

      emit("resetarAutenticacao");
    };

    const receberResultadoBiometriaSolicitante = (value) => {
      biometriaVerificacaoSolicitante.value = value;
    };

    const receberResultadoBiometriaAlmoxarife = (value) => {
      biometriaVerificacaoAlmoxarife.value = value;
    };

    const atualizarTemplatesBiometria = () => {
      emit("atualizarTemplates");
    };

    const verificarPinSolicitante = async () => {
      if (pin.value == "") {
        quasar.notify({
          message: "O campo não pode estar vazio",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disable.value = false;
        return;
      }
      try {
        const response = await store.dispatch("requisicao/checarPin", {
          pin: pin.value,
          user_id: props.usuario.idTabela,
        });
        if (response.data.result.pin_correto) {
          quasar.notify({
            message: "PIN validado com Sucesso.",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          enviarAutenticacao("pin", pin.value, "solicitante");
          pin.value = "";
          disable.value = false;
          return;
        } else {
          quasar.notify({
            message: "PIN digitado, não corresponde ao pin do usuário!",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          disable.value = false;
        }
      } catch (error) {
        quasar.notify({
          message: "Erro ao validar pin",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const verificarPinAlmoxarife = async () => {
      if (pin.value == "") {
        quasar.notify({
          message: "O campo não pode estar vazio",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disable.value = false;
        return;
      }
      try {
        const response = await store.dispatch("requisicao/checarPin", {
          pin: pin.value,
          user_id: userLogado.value.id,
        });
        if (response.data.result.pin_correto) {
          quasar.notify({
            message:
              "PIN validado com Sucesso, a retirada de ferramentas será finalizada!",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          enviarAutenticacao("pin", pin.value, "almoxarife");
          return;
        } else {
          quasar.notify({
            message: "PIN digitado, não corresponde ao pin do usuário!",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          disable.value = false;
        }
      } catch (error) {
        quasar.notify({
          message: "Erro ao validar pin",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const receberUserLogado = async () => {
      try {
        const response = await store.dispatch(
          "ferramentaria/receberUserLogado"
        );
        userLogado.value = response.data;
      } catch (error) {
        console.log(error);
      }
    };
    const autoSelecionarAutenticacao = () => {
      if (
        metodoAutenticacao.value[individoAutenticacao.value].metodos.length ==
          0 ||
        metodoAutenticacao.value[individoAutenticacao.value].metodos ==
          undefined
      ) {
        return;
      }
      metodoAutenticacao.value[individoAutenticacao.value].metodos.sort();
    };

    const enviarSetupConfiguracao = () => {
      emit("enviarSetupConfiguracao", respostas.value);
    };

    const fecharFacial = async () => {
      facial.value = false;
    };

    const receberFace = async (faceImage) => {
      base64.value = faceImage;

      facial.value = false;

      quasar.notify({
        message: "Face recebida com sucesso",
        color: "positive",
        actions: [
          {
            label: "fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    watch(
      () => setupDado.dadoSetupAutenticacao.value,
      () => {
        receberDadoSetup();
      }
    );

    watch(
      () => props.fazerAutenticacao,
      () => {
        verificarTipoAutenticacao();
      }
    );

    watch([() => props.resetar], () => {
      resetarVariaveis();
    });

    watch(
      [() => solicitanteAuteticacao.value, () => almoxarifeAutenticacao.value],
      () => {
        definirLabelBotao();
      }
    );

    watch(
      [() => solicitanteAuteticacao.value, () => props.autenticacao],
      () => {
        autoSelecionarAutenticacao();
      }
    );

    watch(
      () => metodoSolicitante.value,
      () => {
        pin.value = "";
        biometriaVerificacaoSolicitante.value = false;
      }
    );

    watch(
      () => props.atualizarUserLogado,
      () => {
        receberUserLogado();
      }
    );

    onMounted(() => {
      receberDadoSetup();
      definirLabelBotao();
      receberUserLogado();
    });

    return {
      setupDado,
      dado,
      biometriaModal,
      receberDadoSetup,
      solicitanteAuteticacao,
      metodoAutenticacao,
      almoxarifeAutenticacao,
      file,
      iniciarAutenticacao,
      labelBotao,
      receberUrlEmprestimoAutenticacao,
      salvarAssinatura,
      receberAssinatura,
      verificarTipoAutenticacao,
      individoAutenticacao,
      mobile,
      disable,
      converterBase64Arquivo,
      base64,
      selecionarTipoAutenticacaoAlmoxarife,
      pin,
      recebeBiometria,
      biometriaVerificacaoSolicitante,
      biometriaVerificacaoAlmoxarife,
      receberFace,
      receberResultadoBiometriaSolicitante,
      receberResultadoBiometriaAlmoxarife,
      observacao,
      atualizarTemplatesBiometria,
      verificarPinAlmoxarife,
      enviarAutenticacao,
      userLogado,
      metodoSolicitante,
      metodoAlmoxarife,
      resetarVariaveis,
      respostas,
      enviarSetupConfiguracao,
      getLabelBotao,
      facial,
      fecharFacial,
    };
  },
};
</script>

<style scoped>
.imagem-biometria {
  height: 80px;
  width: 80px;
  cursor: pointer;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.titulo-autenticacao {
  font-size: 17px;
}
.status-autenticacao {
  font-size: 17px;
}
@media (max-width: 600px) {
  .container-selecao-autenticacao {
    margin: 10px 0px 0px 0px;
  }
  .container-autenticacao-pin {
    margin: 15px 0px 0px 0px;
  }
  .container-autenticacao-assinatura {
    margin: 15px 0px 0px 0px;
  }
  .titulo-autenticacao {
    font-size: 15px;
  }
  .status-autenticacao {
    font-size: 15px;
    margin-top: 10px;
  }
}
</style>
